<!--
  Built wide on purpose: the viewBox matches the shape of the band it sits in,
  so the scene fills the dialog edge to edge instead of being letterboxed into
  the middle with empty margins either side.

  Each instance is two nested groups. The outer one carries the `transform`
  attribute that places it; the inner one is what CSS animates. In SVG a CSS
  `transform` *replaces* the attribute rather than adding to it, so animating
  the placed group directly would drag every tile back to the origin.
-->
<svg
  class="visual"
  viewBox="0 0 1120 250"
  preserveAspectRatio="xMidYMid meet"
  role="img"
  aria-label="Demand rising and falling while Fleet adds and removes game server instances"
>
  <defs>
    <pattern
      id="whatsNewGrid"
      width="36"
      height="36"
      patternUnits="userSpaceOnUse"
    >
      <circle cx="2" cy="2" r="1.4" class="grid-dot" />
    </pattern>
    <linearGradient id="whatsNewArea" x1="0" y1="0" x2="0" y2="1">
      <stop
        offset="0%"
        stop-color="var(--fuse-primary-500)"
        stop-opacity="0.42"
      />
      <stop offset="100%" stop-color="var(--fuse-primary-500)" stop-opacity="0" />
    </linearGradient>
    <filter id="whatsNewGlow" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation="7" result="blur" />
      <feMerge>
        <feMergeNode in="blur" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>

  <!-- A faint grid, so the scene has a floor to sit on -->
  <rect class="grid" x="0" y="0" width="1120" height="250" />

  <!-- The ceiling the deployment never scales past -->
  <line class="limit-line" x1="0" y1="34" x2="1030" y2="34" />
  <text class="limit-label" x="1044" y="38">Maximum</text>

  <!-- Demand: filled area, drawn line, travelling head -->
  <path
    class="demand-area"
    d="M0 168 C 170 168, 230 58, 420 58 S 720 58, 830 120 S 990 168, 1120 168 L 1120 186 L 0 186 Z"
  />
  <path
    class="demand-track"
    d="M0 168 C 170 168, 230 58, 420 58 S 720 58, 830 120 S 990 168, 1120 168"
  />
  <path
    class="demand-line"
    d="M0 168 C 170 168, 230 58, 420 58 S 720 58, 830 120 S 990 168, 1120 168"
  />
  <path
    class="demand-flow"
    d="M0 168 C 170 168, 230 58, 420 58 S 720 58, 830 120 S 990 168, 1120 168"
  />
  <circle class="demand-dot" r="7" />

  <!-- Instances. The first two are the minimum and never leave. -->
  <g transform="translate(40 200)">
    <g class="instance instance--fixed">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
  <g transform="translate(201 200)">
    <g class="instance instance--fixed">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
  <g transform="translate(362 200)">
    <circle class="pop-ring pop-ring--1" cx="36" cy="20" r="6" />
    <g class="instance instance--scaled-1">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
  <g transform="translate(523 200)">
    <circle class="pop-ring pop-ring--2" cx="36" cy="20" r="6" />
    <g class="instance instance--scaled-2">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
  <g transform="translate(684 200)">
    <circle class="pop-ring pop-ring--3" cx="36" cy="20" r="6" />
    <g class="instance instance--scaled-3">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
  <g transform="translate(845 200)">
    <circle class="pop-ring pop-ring--4" cx="36" cy="20" r="6" />
    <g class="instance instance--scaled-4">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>

  <!-- The spare, always one slot past the last running instance -->
  <g transform="translate(1006 200)">
    <g class="instance instance--buffer">
      <rect class="instance-body" width="72" height="40" rx="10" />
      <rect class="instance-led" x="14" y="17" width="7" height="7" rx="3.5" />
      <rect class="instance-bar" x="30" y="18" width="28" height="5" rx="2.5" />
    </g>
  </g>
</svg>
